<template>
  <div>
    <div class="navigation">
      <router-link to="/"
        ><div class="top-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
            <defs></defs>
            <path
              class="a"
              d="M70.89,55.62c-3.72,0-6.07,2.06-6.18,4.66-.12,1.9,1.31,3.18,3.29,4.5l1.64,1a11.53,11.53,0,0,0,1.18,0c4.14-.07,6.61-2.33,6.68-5.29a.49.49,0,0,0,0-.17C77.09,57.48,74.55,55.62,70.89,55.62Z"
            />
            <path
              class="a"
              d="M0,0V112H112V0ZM64.26,22.42l7.1,3.14L78,22.4l.33.36-6.7,7.34h-.54l-7.14-7.35ZM40,51.05v-.47A7.31,7.31,0,0,0,47.5,45a10.9,10.9,0,0,0,.3-3c-.14-4.12-2.36-7-6.23-7H38.26V63.67c0,1.69,1.49,2.7,3.18,2.7h.61v.71H27.36v-.71H28c1.69,0,2.46-1,2.46-2.7V36.6c0-1.63-.84-2.94-2.45-2.94h-.61v-.41l16.13.08c8.27,0,11.86,4,12,9.26C55.84,50.93,46.9,55.58,40,51.05Zm43.08,6.81c-.26,5.59-4,9.14-10.29,9.87l4.94,3a8.57,8.57,0,0,1,4.25,8c-.29,6.3-4.93,10-12.49,10-4.24,0-8.22-1.09-9.94-2.91-.78-2-.12-6,1.12-8.17h.41c-.37,5,3.25,9.15,8.92,9.06,4.11-.08,6.53-2.46,6.53-5.49,0-2-1.24-3.28-3.78-5l-9-5.61c-3.26-2.21-4.87-5.19-4.53-8.72a8.9,8.9,0,0,1,2.28-5.52,11.1,11.1,0,0,1,7.67-3,7,7,0,0,1,1.79.21l-5.8-3.86c-3.33-2.21-5-5.18-4.63-8.71.41-5,4.08-8.52,10.18-8.52,1.56,0,4.38.4,6.59.4h3l-.63,7.11h-.47c0-2.85-2.73-5.47-6.82-5.47-3.81,0-6.21,2.16-6.33,4.75-.12,1.91,1.34,3.18,3.37,4.5l9.23,6C81.61,51.7,83.29,54.24,83.08,57.86Z"
            />
            <g class="b">
              <path
                class="c"
                d="M27.11,84.13V76.36H33v1.52H28.79v1.57h3.67V81H28.79v1.64H33v1.52Z"
              />
            </g>
            <g class="b">
              <path
                class="c"
                d="M39.82,84.13l-1.66-2.49H36.81v2.49H35.1V76.36h3.55a3.16,3.16,0,0,1,2.16.67,2.37,2.37,0,0,1,.78,1.89v0a2.49,2.49,0,0,1-.46,1.54,2.61,2.61,0,0,1-1.21.87l1.9,2.78Zm0-5.12a1,1,0,0,0-.35-.83,1.55,1.55,0,0,0-1-.28h-1.7v2.23h1.73a1.39,1.39,0,0,0,1-.3,1,1,0,0,0,.34-.8Z"
              />
              <path
                class="c"
                d="M49.31,80.25a2.36,2.36,0,0,1-.67.86,2.78,2.78,0,0,1-1,.51,4,4,0,0,1-1.22.18h-1.3v2.33H43.41V76.36h3.17a3.73,3.73,0,0,1,1.25.19,2.52,2.52,0,0,1,.93.55,2.41,2.41,0,0,1,.59.85A2.75,2.75,0,0,1,49.56,79v0A2.61,2.61,0,0,1,49.31,80.25Zm-1.48-1.17a1.06,1.06,0,0,0-.38-.88,1.54,1.54,0,0,0-1-.3H45.12v2.37h1.35a1.42,1.42,0,0,0,1-.33,1.12,1.12,0,0,0,.36-.84Z"
              />
            </g>
          </svg></div>
        </router-link>
      <router-link to="/" :class="['nav-item', $route.path == '/' ? 'active' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="29"
          viewBox="0 0 29 29"
        >
          <g>
            <g>
              <path
                d="M12.982 3.257v6.468a3.26 3.26 0 0 1-3.257 3.257H3.257A3.26 3.26 0 0 1 0 9.725V3.257A3.26 3.26 0 0 1 3.257 0h6.468a3.26 3.26 0 0 1 3.257 3.257zm-2.2 0c0-.583-.474-1.057-1.057-1.057H3.257c-.583 0-1.057.474-1.057 1.057v6.468c0 .583.474 1.057 1.057 1.057h6.468c.583 0 1.056-.474 1.056-1.057zm17.382.043v6.381c0 1.82-1.48 3.301-3.3 3.301h-6.381c-1.82 0-3.3-1.48-3.3-3.3V3.3c0-1.82 1.48-3.3 3.3-3.3h6.38c1.82 0 3.301 1.48 3.301 3.3zm-2.2 0c0-.606-.494-1.1-1.1-1.1h-6.381c-.607 0-1.1.494-1.1 1.1v6.381c0 .607.493 1.1 1.1 1.1h6.38c.607 0 1.1-.493 1.1-1.1zM12.982 18.44v6.467a3.26 3.26 0 0 1-3.257 3.257H3.257A3.26 3.26 0 0 1 0 24.907V18.44a3.26 3.26 0 0 1 3.257-3.257h6.468a3.26 3.26 0 0 1 3.257 3.257zm-2.2 0c0-.584-.474-1.058-1.057-1.058H3.257c-.583 0-1.057.474-1.057 1.057v6.468c0 .583.474 1.057 1.057 1.057h6.468c.583 0 1.056-.474 1.056-1.057zm17.382.043v6.38c0 1.82-1.48 3.301-3.3 3.301h-6.381c-1.82 0-3.3-1.48-3.3-3.3v-6.381c0-1.82 1.48-3.301 3.3-3.301h6.38c1.82 0 3.301 1.48 3.301 3.3zm-2.2 0c0-.607-.494-1.1-1.1-1.1h-6.381c-.607 0-1.1.493-1.1 1.1v6.38c0 .607.493 1.1 1.1 1.1h6.38c.607 0 1.1-.493 1.1-1.1z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Početna</div>
      </router-link>
      <div :class="['nav-item', $route.path.includes('/case') || $route.path.includes('/archived-case') ? 'active' : '']">
        <router-link to="/cases">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          >
            <g>
              <g>
                <path
                  d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z"
                />
              </g>
            </g>
          </svg>
        </router-link>
        <div class="nav-item-hover">Predmeti</div>
      </div>
      <router-link to="/kalendar" :class="['nav-item', $route.path == '/kalendar' ? 'active' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
        >
          <g>
            <g>
              <path
                d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Kalendar</div>
      </router-link>
      <router-link to="/osobe" :class="['nav-item', $route.path.includes('/osobe') || $route.path.includes('/institucije') ? 'active' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 31 31"
        >
          <g>
            <g>
              <path
                d="M5.14 17.018a12.366 12.366 0 0 1 6.182-4.802 6.548 6.548 0 0 1-2.38-5.052C8.942 3.55 11.88.609 15.49.609s6.547 2.94 6.547 6.555c0 2.045-.94 3.875-2.411 5.078 2.452.879 4.599 2.523 6.096 4.75a1.158 1.158 0 1 1-1.923 1.295 10.055 10.055 0 0 0-8.36-4.452c-3.37 0-6.5 1.672-8.372 4.473a1.157 1.157 0 0 1-1.607.32 1.16 1.16 0 0 1-.319-1.61zm6.12-9.854a4.237 4.237 0 0 0 4.23 4.234c2.331 0 4.229-1.9 4.229-4.234a4.237 4.237 0 0 0-4.23-4.235c-2.332 0-4.23 1.9-4.23 4.235zm8.85 13.987l-1.727 1.248a.727.727 0 0 0-.267.815l.696 2.018c.03.09.04.178.037.262-.025.542-.703.913-1.201.553L15.92 24.8a.735.735 0 0 0-.862 0l-1.727 1.247c-.498.36-1.18-.01-1.201-.553a.742.742 0 0 1 .037-.262l.695-2.018a.727.727 0 0 0-.266-.815l-1.728-1.248c-.574-.415-.28-1.4.431-1.4h2.136c.317 0 .599-.122.697-.423l.66-2.031a.72.72 0 0 1 .697-.504.72.72 0 0 1 .698.504l.66 2.031c.098.3.38.423.697.423h2.135c.71 0 1.006.985.431 1.4zm9.908 4.06L28.29 26.46a.727.727 0 0 0-.266.815l.695 2.019c.03.09.041.178.037.261-.024.543-.703.913-1.2.554l-1.728-1.248a.735.735 0 0 0-.862 0l-1.728 1.248c-.498.36-1.18-.011-1.201-.554a.748.748 0 0 1 .038-.261l.695-2.019a.727.727 0 0 0-.267-.815l-1.727-1.248c-.575-.415-.28-1.4.43-1.4h2.136c.318 0 .6-.122.697-.422l.66-2.032a.72.72 0 0 1 .698-.504.72.72 0 0 1 .697.504l.66 2.032c.098.3.38.423.697.423h2.136c.71 0 1.005.984.43 1.4zm-19.815 0L8.475 26.46a.727.727 0 0 0-.266.815l.696 2.019c.03.09.04.178.037.261-.025.543-.704.913-1.201.554L6.013 28.86a.735.735 0 0 0-.862 0l-1.728 1.248c-.497.36-1.18-.011-1.2-.554a.748.748 0 0 1 .037-.261l.695-2.019a.727.727 0 0 0-.267-.815L.961 25.211c-.575-.415-.28-1.4.431-1.4h2.135c.318 0 .6-.122.698-.422l.66-2.032a.72.72 0 0 1 .697-.504.72.72 0 0 1 .697.504l.66 2.032c.098.3.38.423.698.423h2.135c.71 0 1.006.984.43 1.4z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Osobe i institucije</div>
      </router-link>
      <router-link to="/projects" :class="['nav-item', $route.path.includes('/projects') || $route.path.includes('/finished-projects') ? 'active' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="27"
          viewBox="0 0 29 27"
        >
          <g>
            <g>
              <path
                d="M28.458 9.8l-1.472 15.355c-.068 1.033-.964 1.845-2.04 1.845H4.242c-1.023 0-1.898-.776-2.036-1.805l-.004-.039L.73 9.796c-.05-.378.065-.767.315-1.062a1.414 1.414 0 0 1 1.081-.499h1.141l-.385-2.501c-.066-.398.05-.81.322-1.132.27-.318.66-.5 1.07-.5h1.843l-.382-2.435A1.4 1.4 0 0 1 6.057.533c.27-.318.66-.501 1.07-.501h14.967c.41 0 .798.176 1.065.484.268.309.387.724.328 1.138L23.082 4.1h1.864c.41 0 .797.176 1.064.484.268.308.388.722.329 1.136l-.387 2.514h1.11c.419 0 .813.182 1.082.5.25.294.364.683.314 1.065zM8.31 4.101h12.576l.314-1.903H8.012zM5.46 8.235h18.3l.303-1.967H5.157zm20.764 2.166H2.964l1.384 14.436 20.493-.003zM9.472 15.374c0-.597.486-1.083 1.084-1.083h8.076c.598 0 1.084.486 1.084 1.083s-.486 1.083-1.084 1.083h-8.076a1.084 1.084 0 0 1-1.084-1.083z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Projekti</div>
      </router-link>
      <router-link to="/u-pripremi" class="nav-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
        >
          <g>
            <g>
              <path
                d="M24.46 13.36l-4.02 2.009 4.02 2.01a.978.978 0 0 1 0 1.748l-11.538 5.769a.978.978 0 0 1-.875 0L.51 19.127a.978.978 0 0 1 0-1.748l4.02-2.01-4.02-2.01a.978.978 0 0 1 0-1.749L4.53 9.6.51 7.59a.978.978 0 0 1 0-1.748L12.047.073a.978.978 0 0 1 .875 0L24.46 5.842a.978.978 0 0 1 0 1.749L20.44 9.6l4.02 2.01a.978.978 0 0 1 0 1.748zM3.134 6.715l9.35 4.675 9.352-4.675-9.351-4.675zm15.12 9.746l-5.332 2.665a.978.978 0 0 1-.875 0l-5.33-2.665-3.583 1.791 9.35 4.675 9.352-4.675zm3.582-3.977l-3.582-1.791-5.332 2.665a.978.978 0 0 1-.875 0l-5.33-2.665-3.583 1.79 9.35 4.676z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Komunikacija</div>
      </router-link>
      <div class="nav-item nav-grey">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="32"
          viewBox="0 0 23 32"
        >
          <g>
            <g>
              <path
                d="M12.19 6.376a3.736 3.736 0 0 1 3.732-3.732 3.736 3.736 0 0 1 3.732 3.732 3.736 3.736 0 0 1-3.732 3.732 3.736 3.736 0 0 1-3.732-3.732zm2.488 0c0 .686.558 1.244 1.244 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.686 0-1.244.558-1.244 1.244zm7.463 8.645v5.473a3.738 3.738 0 0 1-2.487 3.519v6.743a1.244 1.244 0 1 1-2.488 0v-7.774c0-.687.557-1.244 1.244-1.244.685 0 1.244-.558 1.244-1.244v-5.473c0-.686-.559-1.244-1.244-1.244h-2.24a1.244 1.244 0 1 1 0-2.488h2.24a3.736 3.736 0 0 1 3.731 3.732zM0 12.533a3.736 3.736 0 0 1 3.732-3.732h4.975a3.736 3.736 0 0 1 3.732 3.732v6.78c0 .463-.086.908-.24 1.318a1.245 1.245 0 0 0 1.235 1.107c.687 0 1.244.557 1.244 1.244v7.774a1.244 1.244 0 0 1-2.488 0v-6.743a3.75 3.75 0 0 1-1.804-1.37c-.14.072-.285.135-.435.188v7.925a1.244 1.244 0 1 1-2.488 0V21.8c0-.687.557-1.244 1.244-1.244.686 0 1.244-.558 1.244-1.244v-6.779c0-.686-.558-1.244-1.244-1.244H3.732c-.686 0-1.244.558-1.244 1.244v6.78c0 .685.558 1.243 1.244 1.243.687 0 1.244.557 1.244 1.244v8.956a1.244 1.244 0 1 1-2.488 0v-7.912A3.739 3.739 0 0 1 0 19.325zm2.488-8.645A3.736 3.736 0 0 1 6.219.156a3.736 3.736 0 0 1 3.732 3.732A3.736 3.736 0 0 1 6.22 7.62a3.736 3.736 0 0 1-3.731-3.732zm2.488 0c0 .686.558 1.244 1.243 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.685 0-1.243.558-1.243 1.244z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">CRM</div>
      </div>
      <div to="#" class="nav-item nav-grey">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="34"
          viewBox="0 0 28 34"
        >
          <g>
            <g>
              <path
                d="M4.893 17.377a2.497 2.497 0 0 1-.56-2.033L6.535 2.137A2.498 2.498 0 0 1 9.01.04h9.657c1.233 0 2.273.88 2.474 2.095l2.203 13.207a2.497 2.497 0 0 1-.56 2.033 2.5 2.5 0 0 1-1.915.887H6.809a2.508 2.508 0 0 1-1.916-.886zm1.782-1.644a.126.126 0 0 0 .03.108c.028.034.06.048.103.048H20.87a.128.128 0 0 0 .104-.048.127.127 0 0 0 .029-.11L18.8 2.524a.135.135 0 0 0-.133-.11H9.01a.133.133 0 0 0-.132.11zm20.908 2.458c0 .654-.533 1.187-1.188 1.187-.803 0-1.456.652-1.456 1.454v5.283c0 .655-.533 1.187-1.188 1.187h-8.725v4.23h4.76c.655 0 1.188.532 1.188 1.187 0 .654-.533 1.187-1.188 1.187H7.891a1.189 1.189 0 0 1-1.188-1.187c0-.655.533-1.187 1.188-1.187h4.76v-4.23H3.926a1.189 1.189 0 0 1-1.188-1.187v-5.283c0-.802-.653-1.454-1.456-1.454A1.189 1.189 0 0 1 .094 18.19c0-.655.533-1.187 1.188-1.187a3.837 3.837 0 0 1 3.733 2.972c.476-.212 1.001-.33 1.554-.33h14.539a3.81 3.81 0 0 1 1.553.33 3.837 3.837 0 0 1 3.734-2.972c.655 0 1.188.532 1.188 1.187zm-5.02 6.737v-1.454c0-.802-.652-1.455-1.455-1.455H6.568c-.802 0-1.455.653-1.455 1.455v1.454z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Ured</div>
      </div>
      <router-link to="/sifarnik" :class="['nav-item', $route.path == '/tarife' ? 'active' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g>
            <g>
              <path
                d="M5.183 12.344c0-.615.5-1.115 1.115-1.115h4.253c.614 0 1.115.5 1.115 1.115s-.5 1.115-1.115 1.115H6.298c-.615 0-1.115-.5-1.115-1.115zm0 4.319c0-.615.5-1.115 1.115-1.115h8.24a1.116 1.116 0 0 1 0 2.23h-8.24c-.615 0-1.115-.5-1.115-1.115zm0 4.318c0-.615.5-1.115 1.115-1.115h8.24a1.116 1.116 0 0 1 0 2.23h-8.24c-.615 0-1.115-.5-1.115-1.115zm19.166 5.65a1.052 1.052 0 0 1-.549.117h-.021c-.363 0-.708-.137-.971-.386l-2.305-1.505v4.35a1.457 1.457 0 0 1-.724 1.334l-.011.006a1.252 1.252 0 0 1-1.537-.284l-1.671-1.532-2.122 1.889a1.445 1.445 0 0 1-1.929 0l-2.091-1.889-2.09 1.887a1.52 1.52 0 0 1-.95.381h-.023a1.444 1.444 0 0 1-.961-.382l-2.12-1.888-1.723 1.553a1.474 1.474 0 0 1-1.618.28l-.008-.003a1.622 1.622 0 0 1-.922-1.29L0 29.243V8.237A3.35 3.35 0 0 1 3.266 5.05h.722V3.734C3.987 2.094 5.456.759 7.26.759h14.917a2.966 2.966 0 0 1 .193.002c.768.032 1.477.36 1.997.926.518.562.787 1.293.758 2.057v21.542a1.41 1.41 0 0 1-.777 1.346zM20.503 8.259v14.056c.452 0 1.287.195 1.494.402l.899.826V3.713l.002-.02a.647.647 0 0 0-.685-.704H7.26c-.504 0-1.044.3-1.044.746V5.05h11.344c1.65 0 2.942 1.409 2.942 3.208zM2.23 27.489l.979-.865a1.542 1.542 0 0 1 2.012-.044l.014.011 2.124 1.891 2.102-1.897.01-.009a1.52 1.52 0 0 1 .947-.332c.342 0 .678.118.946.332l.011.01 2.07 1.894 2.119-1.886a1.377 1.377 0 0 1 1.916.048l.793.776V8.258c0-.475-.25-.978-.712-.978H3.284c-.55.025-.999.452-1.054.998z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Šifarnici</div>
      </router-link>
      <div to="#" class="nav-item nav-grey">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="29"
          viewBox="0 0 29 29"
        >
          <g>
            <g>
              <path
                d="M28.367 13.242a1.066 1.066 0 0 1-1.062.995H15.84a1.065 1.065 0 0 1-1.064-1.064V1.72c0-.56.438-1.026.996-1.062.264-.017.531-.025.793-.025 1.434 0 2.836.254 4.169.755a11.809 11.809 0 0 1 7.633 11.854zm-2.11-1.133A9.633 9.633 0 0 0 23.42 5.6a9.648 9.648 0 0 0-6.515-2.835v9.344zm-2.612 4.282a11.784 11.784 0 0 1-4.997 10.454A11.772 11.772 0 0 1 11.835 29c-3.161 0-6.133-1.23-8.369-3.463A11.743 11.743 0 0 1 0 17.175a11.74 11.74 0 0 1 3.466-8.362 11.759 11.759 0 0 1 8.366-3.464c.261 0 .526.009.788.026.558.035.996.502.996 1.061v8.96h8.967c.56 0 1.026.437 1.062.995zm-10.029 1.132v9.187a9.77 9.77 0 0 0 5.499-3.115 9.654 9.654 0 0 0 2.421-6.072zm-7.85 7.22a9.567 9.567 0 0 0 5.721 2.124v-7.84zm-.794-14.426a9.628 9.628 0 0 0-2.843 6.858c0 2.206.756 4.354 2.131 6.065l7.227-7.221V7.482a9.648 9.648 0 0 0-6.515 2.835z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">Analitika</div>
      </div>
      <div to="#" class="nav-item nav-grey"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="27"
          viewBox="0 0 25 27"
        >
          <g>
            <g>
              <path
                d="M25 20.25c0 2.617-2.143 4.746-4.777 4.746a4.771 4.771 0 0 1-2.638-.791l-2.503 2.486a1.062 1.062 0 0 1-.75.309c-.273 0-.544-.103-.751-.31a1.05 1.05 0 0 1 0-1.49l2.538-2.523a4.693 4.693 0 0 1-.673-2.427c0-2.617 2.143-4.746 4.777-4.746 2.634 0 4.777 2.129 4.777 4.746zm-2.123 0a2.648 2.648 0 0 0-2.654-2.637 2.648 2.648 0 0 0-2.654 2.637 2.648 2.648 0 0 0 2.654 2.637 2.648 2.648 0 0 0 2.654-2.637zm-9.873 1.476c0 .583-.475 1.055-1.061 1.055H3.185a1.06 1.06 0 0 0-1.062 1.055 1.06 1.06 0 0 0 1.062 1.055h6.422c.587 0 1.062.472 1.062 1.054 0 .583-.475 1.055-1.062 1.055H3.185C1.429 27 0 25.58 0 23.836V3.164C0 1.419 1.43 0 3.185 0h18.63c.587 0 1.062.472 1.062 1.055v10.968c0 .583-.475 1.055-1.062 1.055a1.058 1.058 0 0 1-1.061-1.055V2.11H3.184a1.06 1.06 0 0 0-1.06 1.055v17.69c.331-.118.689-.182 1.06-.182h1.062V5.273c0-.582.476-1.054 1.062-1.054.586 0 1.061.472 1.061 1.054v15.399h5.574c.586 0 1.061.472 1.061 1.054z"
              />
            </g>
          </g></svg>
          <div class="nav-item-hover">Znanje</div>
        </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import gsap from 'gsap'
export default {
  mounted() {
    $(".mobile-menu-wrapper").click(function(){
      $(".navigation").toggleClass("opened");
    });

    
    //nav item hovers
    $(".nav-item").hover(
      function () {
          gsap.to($(this).find('.nav-item-hover'),0.5,{display:'flex', opacity:1, left:'5rem'})
          gsap.to($(this).find('svg path'),0.3,{fill:'#3325ae'})
      }, 
      function () {
          gsap.to($(this).find('.nav-item-hover'),0.5,{display:'none', opacity:0, left:'4rem'})
          gsap.to($(this).find('svg path'),0.3,{fill:'#2b2b41'})

      }
    );
  },
  destroyed() {
    $(".mobile-menu-wrapper").off();
    $(".nav-item").off();
  },
};
</script>

<style>
</style>